import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  DoCheck,
  HostListener,
  OnDestroy
} from "@angular/core";

import { ApiService } from "../../services/api.service";
import { SharedService } from "../../services/shared.service";
import { MyAuthService } from "./../../authentication/auth.service";
import { Router } from "@angular/router";
import { ConfirmDialogService } from "./../confirm-dialog/confirm-dialog.service";
import { MatAutocompleteTrigger } from "@angular/material";
import * as $ from "jquery";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public searchingText = "";
  public placeholder = "Search Stock/Mutual Fund";
  public sobject = { companyname: "", sectorname: "" };
  public getSlist = { companies: { data: [] }, mutual_funds: { data: [] } };
  public userInfo: any;
  public isPartnerLogin = false;
  public isLoggedIn = false;
  private currentUrl = "";
  public showPlans = false;
  public showMobileVerify = false;
  public showMenu = false;

  public currentCategory = "companies";
  public showSearchResult = false;

  public isA11yMenuOpen = false;
  public fontScale = 100;
  // 4 steps each way from 100%
  private readonly fontScaleLevels = [80, 85, 90, 95, 100, 110, 120, 130, 140];
  public readonly minFontScale = this.fontScaleLevels[0];
  public readonly maxFontScale = this.fontScaleLevels[
    this.fontScaleLevels.length - 1
  ];
  public isHighContrast = false;
  @ViewChild("a11yMenu") a11yMenuRef: ElementRef | undefined;
  private fontObserver: MutationObserver | undefined;
  private fontApplyTimer: any;

  constructor(
    public _api: ApiService,
    private _route: Router,
    public _shared: SharedService,
    private _auth: MyAuthService,
    private _myElement: ElementRef,
    private _confirmDialog: ConfirmDialogService
  ) {
    this._shared.openBenefits.subscribe(openPlans => {
      this.showPlans = openPlans;
    });
    this._shared.showMobileVerify.subscribe(showMobile => {
      this.showMobileVerify = showMobile;
    });
    // this._shared.openLoginRegister.subscribe(openLogin => {
    //   this.showLogin = openLogin;
    // });
    this._auth.userData.subscribe(userInfo => {
      this.userInfo = userInfo;
      this.isLoggedIn = userInfo ? true : false;
      //console.log("$$$$ userInfo $$$$", this.userInfo, this.isLoggedIn);
      if (this.userInfo != null) {
        if (this.userInfo.identity.type_of === "partner") {
          this.isPartnerLogin = true;
        } else {
          this.isPartnerLogin = false;
        }
      } else {
        this.isPartnerLogin = false;
      }
    });
    this._route.events.subscribe(res => {
      // console.log(this._route, 'Current URL');
      this.currentUrl = this._route.url;
    });
  }
  // @ViewChild('autoComplete') autoComplete;
  @ViewChild("autoCompleteMob") autoCompleteMob;
  @ViewChild("autoComplete", { read: MatAutocompleteTrigger })
  autoTrigger: MatAutocompleteTrigger;

  ngOnInit() {
    //console.log("### this.userInfo ###", this.userInfo);
    //console.log('### this.userInfo.hasOwnProperty ###', this.userInfo?.hasOwnProperty("sub"));
    // this.sideBarSettings();
    if (this.userInfo != null) {
      if (this.userInfo.identity.type_of === "partner") {
        this.isPartnerLogin = true;
      } else {
        this.isPartnerLogin = false;
      }
    } else {
      this.isPartnerLogin = false;
    }
    this.loadA11ySettings();
  }

  toggleA11yMenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isA11yMenuOpen = !this.isA11yMenuOpen;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    if (
      this.isA11yMenuOpen &&
      this.a11yMenuRef &&
      !this.a11yMenuRef.nativeElement.contains(event.target)
    ) {
      this.isA11yMenuOpen = false;
    }
  }

  resetFont(): void {
    this.setFontScale(100);
  }

  toggleContrast(): void {
    this.setHighContrast(!this.isHighContrast);
  }

  increaseFont(): void {
    const next = this.fontScaleLevels.find(level => level > this.fontScale);
    this.setFontScale(next || this.maxFontScale);
  }

  decreaseFont(): void {
    const prev = this.fontScaleLevels
      .filter(level => level < this.fontScale)
      .pop();
    this.setFontScale(prev || this.minFontScale);
  }

  private setFontScale(scale: number): void {
    this.fontScale = Math.min(
      this.maxFontScale,
      Math.max(this.minFontScale, scale)
    );
    this.applyFontScale();
    this.watchMainContainer();
    this.saveA11ySetting("a11yFontScale", String(this.fontScale));
  }

  // Most font sizes are fixed px, so scale each element's own font-size inside .main-container
  private applyFontScale(): void {
    const container = document.querySelector(".main-container");
    if (!container) {
      return;
    }
    const elements: any[] = [
      container,
      ...Array.from(container.querySelectorAll("*"))
    ];
    // Disable CSS transitions while measuring, otherwise elements with
    // "transition: all" report their old (scaled) size and get scaled twice
    const root = document.documentElement;
    root.classList.add("a11y-no-transition");
    void root.offsetHeight;

    // Restore original sizes first so computed values are unscaled
    elements.forEach(el => {
      if (el.dataset.a11yFontSize === undefined) {
        el.dataset.a11yFontSize = el.style.fontSize;
      } else {
        el.style.fontSize = el.dataset.a11yFontSize;
      }
    });
    if (this.fontScale !== 100) {
      const sizes = elements.map(el =>
        parseFloat(window.getComputedStyle(el).fontSize)
      );
      elements.forEach((el, i) => {
        if (sizes[i]) {
          el.style.fontSize = (sizes[i] * this.fontScale) / 100 + "px";
        }
      });
    }

    // Flush styles before re-enabling transitions so the new sizes don't animate
    void root.offsetHeight;
    root.classList.remove("a11y-no-transition");
  }

  // Re-apply the font scale when page content changes (route change, API data)
  private watchMainContainer(): void {
    if (this.fontObserver || this.fontScale === 100) {
      return;
    }
    this.fontObserver = new MutationObserver(mutations => {
      // Only new elements inside .main-container need scaling. Text-only changes
      // (e.g. Typed.js typing on the home page) are ignored, otherwise the constant
      // re-scaling blocks the page and the animation appears paused.
      const hasNewElements = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(
          node =>
            node.nodeType === Node.ELEMENT_NODE &&
            ((node as Element).classList.contains("main-container") ||
              !!(node as Element).closest(".main-container"))
        )
      );
      if (!hasNewElements) {
        return;
      }
      clearTimeout(this.fontApplyTimer);
      this.fontApplyTimer = setTimeout(() => {
        if (this.fontScale === 100) {
          this.stopWatchingMainContainer();
        } else {
          this.applyFontScale();
        }
      }, 150);
    });
    this.fontObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  private stopWatchingMainContainer(): void {
    clearTimeout(this.fontApplyTimer);
    if (this.fontObserver) {
      this.fontObserver.disconnect();
      this.fontObserver = undefined;
    }
  }

  ngOnDestroy(): void {
    this.stopWatchingMainContainer();
  }

  private setHighContrast(enabled: boolean): void {
    this.isHighContrast = enabled;
    document.documentElement.classList.toggle("high-contrast", enabled);
    this.saveA11ySetting("a11yHighContrast", enabled ? "1" : "0");
  }

  private loadA11ySettings(): void {
    try {
      const scale = Number(window.localStorage.getItem("a11yFontScale"));
      if (scale) {
        this.setFontScale(scale);
      }
      if (window.localStorage.getItem("a11yHighContrast") === "1") {
        this.setHighContrast(true);
      }
    } catch (e) {}
  }

  private saveA11ySetting(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  close() {
    /* console.log(
      "remove focus",
      document.activeElement,
      this.autoCompleteMob.nativeElement
    );
    console.log(document.activeElement instanceof HTMLElement); */
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    const deskSearch: HTMLElement = document
      .getElementsByClassName("global-search")
      .item(0) as HTMLElement;
    const deskSearch1: HTMLElement = document
      .getElementsByClassName("global-search")
      .item(1) as HTMLElement;
    deskSearch.blur();
    deskSearch1.blur();
    //console.log(this.autoTrigger._handleFocus());
    this.autoCompleteMob.nativeElement.blur();
  }

  loadCompanies(SearchedText, $event) {
    //console.log(SearchedText, $event);
    if (SearchedText.length >= 3) {
      this.sobject.companyname = SearchedText;
      // this._api.PostRequest('companiesListing/page/1', this.sobject).subscribe((resp) => {
      //   if (resp && resp.data.length > 0) {
      //     this.getSlist = resp.data;
      //   } else {

      //   }
      // });
      this._api.getSearchResults(SearchedText).subscribe(resp => {
        //console.log(resp);
        if (resp) {
          this.showSearchResult = true;
          this.getSlist = resp;
          //console.log(this.getSlist);
        } else {
        }
      });
    } else if (SearchedText.length === 0 && SearchedText.length <= 3) {
      this.getSlist = { companies: { data: [] }, mutual_funds: { data: [] } };
      this.showSearchResult = false;
    }
  }

  selectSearchCategory(category) {
    this.currentCategory = category;
  }

  getValue(_event) {
    //console.log("Search", _event);
    this.getSlist = { companies: { data: [] }, mutual_funds: { data: [] } };
    this.searchingText = "";
    // this.close();
    this._route.navigate(["portfolio/" + _event.source.value.co_code + ""]);
  }

  displayFn(inpt) {
    // console.log('value', inpt);
    if (inpt) {
      return inpt.SearchResult;
    } else {
      this.searchingText = "";
      return null;
    }
  }

  searchClear() {
    this.searchingText = "";
    this.showSearchResult = false;
    this.getSlist = { companies: { data: [] }, mutual_funds: { data: [] } };
    // this.close();
  }

  goSearch(id, type) {
    //console.log(id, type);
    this.searchClear();
    // this.close();
    if (type === "company") {
      this._route.navigate(["portfolio/" + id + ""]);
    } else if (type === "scheme") {
      this._route.navigate(["scheme-portfolio/" + id + ""]);
    }
  }

  logout() {
    //console.log("Logout", this._confirmDialog);
    const data = {
      msg: "Are you sure you want to Logout?"
    };
    // this._confirmDialog.confirmThis(data.msg, () => {
    this.closeMenu();
    this._auth.logoutUser();
    // }, () => {
    //   // console.log('No clicked');
    // });
  }

  hideMobileVerifyBox($event) {
    this._shared.toggleMobileVerify(null);
  }

  goToPlan() {
    // this.confirmDialogService.openDialog('');
    if (this.currentUrl === "/" || this.currentUrl === "/?showPlans=1") {
      this._myElement.nativeElement.ownerDocument
        .getElementById("benifits")
        .scrollIntoView({ behavior: "smooth" });
    } else {
      this._shared.goToRoute("/?showPlans=1", 1);
      // this.showPlans = true;
    }
  }

  showLoginbox(eve) {
    this.benefitModalStatus("false");
  }

  closeBenefits() {
    this._shared.toggleBenefits();
  }

  benefitModalStatus($event) {
    let status = true;
    if ($event === "false") {
      status = false;
    }
    // this.showPlans = status;
    this._shared.toggleBenefits();
  }

  closeMenu() {
    this.showMenu = !this.showMenu;
  }

  openMenu() {
    this.showMenu = !this.showMenu;
  }

  sideBarSettings() {
    const navbar = $(".navigation-holder");
    const openBtn = $(".navbar-header .open-btn");
    const closeBtn = $(".navigation-holder .close-navbar");

    openBtn.on("click", function() {
      if (!navbar.hasClass("slideInn")) {
        navbar.addClass("slideInn");
      }
      return false;
    });

    closeBtn.on("click", function() {
      if (navbar.hasClass("slideInn")) {
        navbar.removeClass("slideInn");
      }
      return false;
    });
  }
}
